// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YtcDwgHbNY_uGi5o_yJ0 {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: var(--spacing-xxSmall);
  align-items: baseline;
}

.uvCIN0vjoqYh1sg5xEdG {
  display: flex;
}

.frfRcKNz640XYr2nNUuJ {
  margin-bottom: var(--spacing-small);
}

.DlacL9JoynjucuK43MQI {
  overflow-x: auto;
}

.zoldhlGnlSsLntLEbUwn {
  margin-top: var(--spacing-small);
}

.rMy_bQ8G4Y4Siz7MFIMd {
  margin-top: 10px;
  margin-bottom: var(--spacing-xxSmall);
}

.tCt343Z9q7WraA40b3zs {
  margin-top: var(--spacing-xSmall);
}

.NcgjJgTeEAR8NzyDHE6H {
  display: flex;
  justify-content: space-between;
}

.s6QZXaQrFBhiOIFtCpBZ {
  margin-bottom: var(--spacing-xSmall);
}

.oiZkjVE9VOGTAAJwS9YZ {
  margin: calc(var(--spacing-xSmall) * -1) var(--spacing-xxxSmall) var(--spacing-xSmall);
  display: flex;
  justify-content: flex-end;
}

.XQXltfypSYJZXSvC3zth {
  padding: var(--spacing-xSmall);
  align-items: baseline;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.fVvZeiVCtt0SU9boCT31 {
  padding: var(--spacing-xSmall);
}

@media screen and (max-width: 768px) {
  .NcgjJgTeEAR8NzyDHE6H {
    margin-top: calc(var(--spacing-xSmall) * -1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App/views/PersonalData/PersonalData.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sFAAsF;EACtF,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF","sourcesContent":[".row {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  margin-bottom: var(--spacing-xxSmall);\n  align-items: baseline;\n}\n\n.tooltip-container {\n  display: flex;\n}\n\n.card {\n  margin-bottom: var(--spacing-small);\n}\n\n.table-list {\n  overflow-x: auto;\n}\n\n.card-content {\n  margin-top: var(--spacing-small);\n}\n\n.label {\n  margin-top: 10px;\n  margin-bottom: var(--spacing-xxSmall);\n}\n\n.table-responsible {\n  margin-top: var(--spacing-xSmall);\n}\n\n.content-edit {\n  display: flex;\n  justify-content: space-between;\n}\n\n.dialog-info {\n  margin-bottom: var(--spacing-xSmall);\n}\n\n.dialog-resend-code {\n  margin: calc(var(--spacing-xSmall) * -1) var(--spacing-xxxSmall) var(--spacing-xSmall);\n  display: flex;\n  justify-content: flex-end;\n}\n\n.heading-card {\n  padding: var(--spacing-xSmall);\n  align-items: baseline;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.empty-state-card {\n  padding: var(--spacing-xSmall);\n}\n\n@media screen and (max-width: 768px) {\n  .content-edit {\n    margin-top: calc(var(--spacing-xSmall) * -1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `YtcDwgHbNY_uGi5o_yJ0`,
	"tooltip-container": `uvCIN0vjoqYh1sg5xEdG`,
	"card": `frfRcKNz640XYr2nNUuJ`,
	"table-list": `DlacL9JoynjucuK43MQI`,
	"card-content": `zoldhlGnlSsLntLEbUwn`,
	"label": `rMy_bQ8G4Y4Siz7MFIMd`,
	"table-responsible": `tCt343Z9q7WraA40b3zs`,
	"content-edit": `NcgjJgTeEAR8NzyDHE6H`,
	"dialog-info": `s6QZXaQrFBhiOIFtCpBZ`,
	"dialog-resend-code": `oiZkjVE9VOGTAAJwS9YZ`,
	"heading-card": `XQXltfypSYJZXSvC3zth`,
	"empty-state-card": `fVvZeiVCtt0SU9boCT31`
};
export default ___CSS_LOADER_EXPORT___;
